var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _vm.collections && _vm.collections.length
      ? _c("p", { staticClass: "heading" }, [_vm._v("What to wear")])
      : _vm._e(),
    _vm._v(" "),
    _vm.collections && _vm.collections.length
      ? _c(
          "ul",
          { staticClass: "brands-list" },
          _vm._l(_vm.collections, function(collection) {
            return _c("li", { key: collection.id }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.handleOnCollectionClick(collection)
                    }
                  }
                },
                [_vm._v(_vm._s(collection.name))]
              )
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c("p", { staticClass: "heading" }, [_vm._v("Brands we love right now")]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "brands-list" },
      _vm._l(_vm.brands, function(brand) {
        return _c("li", { key: brand.product_brand_id }, [
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  return _vm.handleOnBrandClick(brand)
                }
              }
            },
            [_vm._v(_vm._s(brand.product_brand_title))]
          )
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "cta" }, [
      _c(
        "button",
        {
          on: {
            click: function($event) {
              return _vm.handleCtaClick()
            }
          }
        },
        [_vm._v("See All Brands")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e7a69d9", { render: render, staticRenderFns: staticRenderFns })
  }
}